/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import form from 'ui/components/registrations/form';

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import EmailTargeting from 'ui/components/registrations/EmailTargeting.vue';
import EmailTemplatePicker from 'shared/ui/components/form-components/pickers/EmailTemplatePicker.vue';

const __vue_script__ = {
    name: 'Emails',

    components: {
        Accordion,
        EmailTargeting,
        EmailTemplatePicker,
    },

    mixins: [form],

    props: {
        settings: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            templates: [],
            enableWaitingListConfirmationEmail: this.settings.manual_approval || (this.settings.self_registered_user_limit && this.settings.self_registered_waiting_list)
        };
    },

    computed: {
        showEmptyState() {
            const s = this.settings;
            const hasSomeEmail = (s.access_type !== 'private' && !s.disable_registration)
                || (s.access_type !== 'private' && s.manual_approval)
                || s.allow_profile_updates
                || (s.access_type !== 'public' && s.enable_private_registration)
                || !s.disable_login || s.manual_approval;
            return !hasSomeEmail;
        }
    },

    async created() {
        try {
            this.templates = await this.$services.emails.getEmailTemplates(this.event._id);
        } catch (error) {
            console.error('[Emails] An error occurred:', error.message);
        }
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"emails",attrs:{"tag":"form","autocomplete":"off"}},[_c('p',[_vm._v(_vm._s(_vm.$t('registration.configuration.emails_intro')))]),(_vm.showEmptyState)?_c('div',{staticClass:"alert alert-info no-emails"},[_c('p',[_vm._v("Based on your settings you don’t have any emails to configure")])]):_vm._e(),_c('accordion',{attrs:{"headers-i18n-prefix":"registration.configuration","default-open-item":"registration_confirmation_email_template","animated":true},scopedSlots:_vm._u([(_vm.settings.access_type !== 'private' && !_vm.settings.disable_registration)?{key:"registration_confirmation_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"registration_confirmation_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.registration_confirmation_email_template_hint')},model:{value:(_vm.innerValue.email_address_confirmation_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "email_address_confirmation_email", $$v)},expression:"innerValue.email_address_confirmation_email"}})]}}:null,(_vm.settings.access_type !== 'private' && _vm.settings.manual_approval)?{key:"confirmation_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"confirmation_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.confirmation_email_template_hint')},model:{value:(_vm.innerValue.manual_approve_new_reg_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "manual_approve_new_reg_email", $$v)},expression:"innerValue.manual_approve_new_reg_email"}})]}}:null,(_vm.settings.access_type !== 'private' && _vm.settings.self_registered_waiting_list)?{key:"waiting_list_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"waiting_list_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.waiting_list_email_template_hint')},model:{value:(_vm.innerValue.manual_approve_new_reg_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "manual_approve_new_reg_email", $$v)},expression:"innerValue.manual_approve_new_reg_email"}})]}}:null,(_vm.settings.allow_profile_updates)?{key:"account_updated_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"account_updated_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.account_updated_email_template_hint')},model:{value:(_vm.innerValue.account_updated_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "account_updated_email", $$v)},expression:"innerValue.account_updated_email"}})]}}:null,(_vm.settings.access_type !== 'public' && _vm.settings.enable_private_registration)?{key:"rsvp_accepted_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"rsvp_accepted_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.rsvp_accepted_email_template_hint')},model:{value:(_vm.innerValue.rsvp_accepted_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "rsvp_accepted_email", $$v)},expression:"innerValue.rsvp_accepted_email"}})]}}:null,(_vm.settings.access_type !== 'public' && _vm.settings.enable_private_registration)?{key:"rsvp_declined_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"rsvp_declined_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.rsvp_declined_email_template_hint')},model:{value:(_vm.innerValue.rsvp_declined_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "rsvp_declined_email", $$v)},expression:"innerValue.rsvp_declined_email"}})]}}:null,(!_vm.settings.disable_login || _vm.enableWaitingListConfirmationEmail)?{key:"login_email_template",fn:function(ref){return [_c('email-targeting',{attrs:{"name":"login_email_template","templates":_vm.templates,"event-id":_vm.event._id,"description":_vm.$t('registration.configuration.login_email_template_hint')},model:{value:(_vm.innerValue.existing_account_confirmation_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "existing_account_confirmation_email", $$v)},expression:"innerValue.existing_account_confirmation_email"}})]}}:null,(!_vm.settings.disable_login)?{key:"unknown_account_email_template",fn:function(ref){return [_c('p',{staticClass:"email-description"},[_vm._v(_vm._s(_vm.$t('registration.configuration.unknown_account_email_template_hint')))]),_c('email-template-picker',{attrs:{"name":"unknown_account_email_template","templates":_vm.templates,"event-id":_vm.event._id,"show-no-send":true},model:{value:(_vm.innerValue.no_account_email),callback:function ($$v) {_vm.$set(_vm.innerValue, "no_account_email", $$v)},expression:"innerValue.no_account_email"}})]}}:null],null,true)})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Emails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__